// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1434":"a5f983982f03df98","1599":"d1ea91e1bbd76b70"}[chunkId] + ".js";
};